module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="panel ' +
((__t = (panelCss)) == null ? '' : __t) +
'">\n    <div class="panel-heading">\n        <h3 class="DescartesUIPanelTitle panel-title">' +
((__t = (requiredParamsFielset)) == null ? '' : __t) +
'</h3>\n    </div>\n    <div class="panel-body">\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (titleInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <p class="DescartesUIText form-control-static Descartes-overflow-auto">' +
((__t = (title)) == null ? '' : __t) +
'</p>\n            </div>\n        </div>\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (layernameInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <p class="DescartesUIText form-control-static Descartes-overflow-auto">' +
((__t = (layerName)) == null ? '' : __t) +
'</p>\n            </div>\n        </div>\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (serverInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <p class="DescartesUIText form-control-static Descartes-overflow-auto">' +
((__t = (urlserver)) == null ? '' : __t) +
'</p>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class="panel ' +
((__t = (panelCss)) == null ? '' : __t) +
'">\n    <div class="panel-heading">\n        <h3 class="DescartesUIPanelTitle panel-title">' +
((__t = (optionalParamsFielset)) == null ? '' : __t) +
'</h3>\n    </div>\n    <div class="panel-body">\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (typeInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <p class="DescartesUIText form-control-static Descartes-overflow-auto">' +
((__t = (type)) == null ? '' : __t) +
'</p>\n            </div>\n        </div>\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (versionInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <p class="DescartesUIText form-control-static Descartes-overflow-auto">' +
((__t = (version)) == null ? '' : __t) +
'</p>\n            </div>\n        </div>\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (stylesInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <p class="DescartesUIText form-control-static Descartes-overflow-auto">' +
((__t = (styles)) == null ? '' : __t) +
'</p>\n            </div>\n        </div>\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (formatInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <p class="DescartesUIText form-control-static Descartes-overflow-auto">\n                    ';

                        _.each(formats,function(aFormat) {
                            if(format===aFormat.value) {
                                print(aFormat.text);
                            }
                        });
                    ;
__p += '\n                </p>\n            </div>\n        </div>\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (legendInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <p class="DescartesUIText form-control-static Descartes-overflow-auto">' +
((__t = (legend)) == null ? '' : __t) +
'</p>\n            </div>\n        </div>\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (metadataUrlInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <p class="DescartesUIText form-control-static Descartes-overflow-auto">' +
((__t = (metadataURL)) == null ? '' : __t) +
'</p>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class="panel ' +
((__t = (panelCss)) == null ? '' : __t) +
'">\n    <div class="panel-heading">\n        <h3 class="DescartesUIPanelTitle panel-title">' +
((__t = (optionsFielset)) == null ? '' : __t) +
'</h3>\n    </div>\n    <div class="panel-body">\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (queryableInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <label class="checkbox-inline">\n                    <input type="hidden" name="queryable" value="false"/>\n                    <input type="checkbox" name="queryable" value="true" ';
if(queryable==true){print('checked');};
__p += ' disabled>&nbsp;\n                </label>\n            </div>\n        </div>\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (sheetableInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <label class="checkbox-inline">\n                    <input type="hidden" name="sheetable" value="false" />\n                    <input type="checkbox" name="sheetable" value="true" ';
if(sheetable==true){print('checked');};
__p += ' disabled>&nbsp;\n                </label>\n            </div>\n        </div>\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (maxScaleInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <p class="DescartesUIText form-control-static Descartes-overflow-auto">' +
((__t = (maxScale)) == null ? '' : __t) +
'</p>\n            </div>\n        </div>\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (minScaleInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <p class="DescartesUIText form-control-static Descartes-overflow-auto">' +
((__t = (minScale)) == null ? '' : __t) +
'</p>\n            </div>\n        </div>\n    </div>\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/Button/ContentTask/bootstrap4/templates/RemoveLayer.ejs
// module id = 406
// module chunks = 0